export default __webpack_public_path__ + "static/media/chat-widget.b9be65a3.svg";